module.exports = __webpack_public_path__ + "img/service-update-checked.19bcc77e.svg";